import { AGUSelectOption } from 'agu_app_shell';

/**
 * Shared `AGUSelectOption` builders for the three finder filter rails
 * (grant/job/people). Kept in one place so `agu-select`'s `{Key,Label}` shape
 * is produced the same way everywhere instead of three near-identical local
 * copies (`grant-filters.component.ts`'s old `ToSelectOptions`, `job-filters
 * .component.ts`'s old `ToOptions`/`WithAll`).
 */

/** Option tables in the shared control's `{Key,Label}` shape, for a fixed local vocabulary. */
export function ToSelectOptions<T extends string>(options: ReadonlyArray<{ value: T; label: string }>): AGUSelectOption[] {
    return options.map((o) => ({ Key: o.value, Label: o.label }));
}

/** `All …` head option + the facet list, for a data-driven select whose values come from the server. */
export function WithAll(allLabel: string, values: readonly string[]): AGUSelectOption[] {
    return [{ Key: '', Label: allLabel }, ...values.map((v) => ({ Key: v, Label: v }))];
}
